/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NavigationLinkModel } from '../../models/navigation-link-model';

export interface GetNavigationLink$Params {
      body?: {
'id'?: number;
}
}

export function GetNavigationLink(http: HttpClient, rootUrl: string, params?: GetNavigationLink$Params, context?: HttpContext): Observable<StrictHttpResponse<NavigationLinkModel>> {
  const rb = new RequestBuilder(rootUrl, GetNavigationLink.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NavigationLinkModel>;
    })
  );
}

GetNavigationLink.PATH = '/api/Navigation/GetNavigationLink';
